
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  
  return (
    <section className="relative min-h-screen md:min-h-[90vh] bg-white rounded-lg pt-16 md:pt-12">
      <div className="flex flex-col lg:grid lg:grid-cols-2 h-full">
        {/* Text Content Side */}
        <div className="relative z-10 flex items-center p-6 lg:p-12 order-1 lg:order-1">
          <div className="w-full">
            <div className="p-4 md:p-10 rounded-xl">
              <h1 className="font-montserrat text-2xl md:text-3xl lg:text-5xl font-extrabold leading-tight mb-4 lg:mb-8 text-primary text-center">
                Transform Unused Space into Bookable Workstations
              </h1>
              <div className="max-w-xl mx-auto">
                <p className="text-gray-800 text-sm md:text-base mb-4 lg:mb-6 font-medium text-center">
                  Quiet Corner creates custom designed, smart pods for professionals on the move—unlocking a new revenue generating amenity for your property with zero cost.
                </p>
              <div className="space-y-4">
                <div className="flex flex-row flex-wrap gap-3 justify-center">
                  <Button 
                    variant="outline"
                    className="border-orange text-orange hover:bg-orange/10 px-6 py-4 lg:px-8 lg:py-6 text-base lg:text-lg transition-colors duration-300 rounded-xl w-full sm:w-auto"
                    onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  >
                    Contact Us About Your Space
                  </Button>
                  <Button 
                    variant="outline" 
                    className="border-orange text-orange hover:bg-orange/10 px-6 py-4 lg:px-8 lg:py-6 text-base lg:text-lg transition-colors duration-300 rounded-xl w-full sm:w-auto"
                    onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
                  >
                    Learn How It Works
                  </Button>
                </div>
                <div className="flex justify-center pt-4">
                  <Button 
                    variant="default"
                    className="bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-4 lg:px-8 lg:py-6 text-base lg:text-lg transition-colors duration-300 rounded-xl w-full sm:w-auto font-bold"
                    onClick={() => navigate('/book')}
                  >
                    Book a Pod Now
                  </Button>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>

        {/* Image Side */}
        <div className="relative lg:relative order-2 lg:order-2 flex items-center h-[40vh] lg:h-[90vh]">
          <div className="relative w-full h-full">
            <img 
              src="/lovable-uploads/f78e07ea-5a48-4f68-bd8f-d3f677be6777.png" 
              alt="Quiet Corner Pod workspace solution"
              className="w-full h-full object-cover rounded-2xl"
            />
            <div className="absolute inset-0 bg-primary/10 mix-blend-soft-light rounded-xl" />
            
            {/* Quote Card - positioned much lower on mobile with more compact design */}
            <div className={`absolute ${isMobile ? 'bottom-[-5px] max-w-[80%] p-2' : 'bottom-8 max-w-xs p-4'} text-center transform -translate-x-1/2 left-1/2`}>
              <p className={`text-white font-medium ${isMobile ? 'text-sm' : 'text-sm'} drop-shadow-md`}>
                "Unlock new revenue per square foot—with no CapEx."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
